import React from "react"
import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { format } from "timeago.js"
import { Helmet } from "react-helmet"
// Components
import Navbar from "../../components/Navbar/Navbar"
import Footer from "../../components/Footer/Footer"
import Table from "../../components/Table/Table"
// Styles
import {
   AddressBlock,
   AddressLine,
   Addresses,
   Column,
   Container,
   Display,
   GeneralInfo,
   Header,
   Info,
   InfoItem,
   InfoLabel,
   Lines,
   Title,
   Wrapper,
} from "./Order.styles"
import { ProductDetail, Image, Details, ProductInfo } from "./Order.styles"

const Order = () => {
   const location = useLocation()
   const { t } = useTranslation()
   const orderId = location.pathname.split("/")[2]
   const order = useSelector((state) =>
      state.order.orders.find((order) => order._id.toString() === orderId)
   )

   const statusTranslation = {
      sent: t("orders.value.status.s1"),
      pending: t("orders.value.status.s2"),
      cancelled: t("orders.value.status.s3"),
   }

   const linesHeader = [
      { name: t("orderPage.header.h1"), size: 50, align: "left" },
      { name: t("orderPage.header.h2"), size: 10, align: "right" },
      { name: t("orderPage.header.h3"), size: 15, align: "right" },
      { name: t("orderPage.header.h4"), size: 25, align: "right" },
   ]

   let linesData = []
   for (let i = 0; i < order.products.length; i++) {
      linesData.push([
         <ProductDetail>
            <Image src={order.products[i].imageUrl} />
            <Details>
               <ProductInfo>
                  <b>{t("favorites.label.l1")} : </b>
                  {order.products[i].model}
               </ProductInfo>
               <ProductInfo>
                  <b>{t("favorites.label.l2")} : </b>
                  {order.products[i].code}
               </ProductInfo>
               {order.products[i].detailedColor.length <= 2 ? (
                  <></>
               ) : (
                  <ProductInfo>
                     <b>{t("favorites.label.l3")} : </b>
                     {order.products[i].detailedColor}
                  </ProductInfo>
               )}
               <ProductInfo>
                  <b>{t("favorites.label.l4")} : </b>{" "}
                  {order.products[i].detailedColor.length <= 2
                     ? order.products[i].detailedColor
                     : order.products[i].size.replace(
                          "undefined - undefined",
                          "unique"
                       )}
               </ProductInfo>
            </Details>
         </ProductDetail>,
         order.products[i].quantity,
         order.products[i].unitPrice + "€",
         order.products[i].info,
      ])
   }

   return (
      <>
         <Helmet>
            <title>{t("orderPage.meta.meta_title")}</title>
            <meta name="robots" content="noindex, nofollow" />
         </Helmet>
         <Container>
            <Navbar bgImageColor="light" />
            <Wrapper>
               <Header>
                  <Title>
                     {t("orderPage.title.t1")}
                     {order.orderNumber}
                  </Title>
                  <Display>
                     <GeneralInfo>
                        <Column>
                           <InfoItem>
                              <InfoLabel>{t("orderPage.label.l1")} :</InfoLabel>
                              <Info>{format(order.createdAt)}</Info>
                           </InfoItem>
                           <InfoItem>
                              <InfoLabel>{t("orderPage.label.l2")} :</InfoLabel>
                              <Info>{format(order.updatedAt)}</Info>
                           </InfoItem>
                           <InfoItem>
                              <InfoLabel>{t("orderPage.label.l3")} :</InfoLabel>
                              <Info>{statusTranslation[order.status]}</Info>
                           </InfoItem>
                           <InfoItem>
                              <InfoLabel>{t("orderPage.label.l4")} :</InfoLabel>
                              <Info>{order.amount}€</Info>
                           </InfoItem>
                           <InfoItem>
                              <InfoLabel>{t("orderPage.label.l5")} :</InfoLabel>
                              <Info>{order.totalQuantity}</Info>
                           </InfoItem>
                        </Column>
                     </GeneralInfo>
                     <Addresses>
                        <Column>
                           <AddressBlock>
                              <InfoLabel>{t("orderPage.label.l6")}</InfoLabel>
                              <Info>
                                 <AddressLine>
                                    {order.deliveryAddress.name}
                                 </AddressLine>
                                 <AddressLine>
                                    {order.deliveryAddress.street}
                                 </AddressLine>
                                 <AddressLine>
                                    {order.deliveryAddress.zipCode}
                                 </AddressLine>
                                 <AddressLine>
                                    {order.deliveryAddress.city}
                                 </AddressLine>
                                 <AddressLine>
                                    {order.deliveryAddress.country}
                                 </AddressLine>
                              </Info>
                           </AddressBlock>
                           <AddressBlock>
                              <InfoLabel>{t("orderPage.label.l8")}</InfoLabel>
                              <Info>{order.deliveryAddress.info}</Info>
                           </AddressBlock>
                        </Column>
                        <Column>
                           <AddressBlock>
                              <InfoLabel>{t("orderPage.label.l7")}</InfoLabel>
                              <Info>
                                 <AddressLine>
                                    {order.invoiceAddress?.name}
                                 </AddressLine>
                                 <AddressLine>
                                    {order.invoiceAddress?.street}
                                 </AddressLine>
                                 <AddressLine>
                                    {order.invoiceAddress?.zipCode}
                                 </AddressLine>
                                 <AddressLine>
                                    {order.invoiceAddress?.city}
                                 </AddressLine>
                                 <AddressLine>
                                    {order.invoiceAddress?.country}
                                 </AddressLine>
                              </Info>
                           </AddressBlock>
                           <AddressBlock>
                              <InfoLabel>{t("orderPage.label.l8")}</InfoLabel>
                              <Info>{order.invoiceAddress?.info}</Info>
                           </AddressBlock>
                        </Column>
                     </Addresses>
                  </Display>
               </Header>
               <Lines>
                  <Title>{t("orderPage.title.t2")}</Title>
                  <Table data={linesData} headers={linesHeader} pageSize={20} />
               </Lines>
            </Wrapper>
            <Footer />
         </Container>
      </>
   )
}

export default Order
